__turbopack_context__.v({
  "accreditation-card": "QvPQ_a_accreditation-card",
  "accreditation-card__body": "QvPQ_a_accreditation-card__body",
  "accreditation-card__content": "QvPQ_a_accreditation-card__content",
  "accreditation-card__logo": "QvPQ_a_accreditation-card__logo",
  "advantage-number": "QvPQ_a_advantage-number",
  "band-title": "QvPQ_a_band-title",
  "callout-icon": "QvPQ_a_callout-icon",
  "card-title": "QvPQ_a_card-title",
  "category-copy": "QvPQ_a_category-copy",
  "compare-check": "QvPQ_a_compare-check",
  "doc-list": "QvPQ_a_doc-list",
  "doc-list__icon": "QvPQ_a_doc-list__icon",
  "eyebrow": "QvPQ_a_eyebrow",
  "faq-art": "QvPQ_a_faq-art",
  "faq-title": "QvPQ_a_faq-title",
  "features": "QvPQ_a_features",
  "fluid-image": "QvPQ_a_fluid-image",
  "format-card": "QvPQ_a_format-card",
  "format-card__label": "QvPQ_a_format-card__label",
  "format-card__title": "QvPQ_a_format-card__title",
  "formats-cta-button": "QvPQ_a_formats-cta-button",
  "hero-intro": "QvPQ_a_hero-intro",
  "hero-video": "QvPQ_a_hero-video",
  "hero-video--desktop": "QvPQ_a_hero-video--desktop",
  "hero-video--phone": "QvPQ_a_hero-video--phone",
  "hero-video__caption": "QvPQ_a_hero-video__caption",
  "lead-copy": "QvPQ_a_lead-copy",
  "map--desktop": "QvPQ_a_map--desktop",
  "map--phone": "QvPQ_a_map--phone",
  "map-frame": "QvPQ_a_map-frame",
  "media-row": "QvPQ_a_media-row",
  "media-row__image": "QvPQ_a_media-row__image",
  "media-row__logo": "QvPQ_a_media-row__logo",
  "page": "QvPQ_a_page",
  "panel-copy": "QvPQ_a_panel-copy",
  "panel-heading": "QvPQ_a_panel-heading",
  "panel-title": "QvPQ_a_panel-title",
  "pm-action": "QvPQ_a_pm-action",
  "pm-image": "QvPQ_a_pm-image",
  "pm-section": "QvPQ_a_pm-section",
  "program-grid": "QvPQ_a_program-grid",
  "program-tile": "QvPQ_a_program-tile",
  "program-tile__caption": "QvPQ_a_program-tile__caption",
  "program-tile__icon": "QvPQ_a_program-tile__icon",
  "program-tile__image": "QvPQ_a_program-tile__image",
  "programs-band__intro": "QvPQ_a_programs-band__intro",
  "programs-band__title": "QvPQ_a_programs-band__title",
  "rotator": "QvPQ_a_rotator",
  "rotator-change": "QvPQ_a_rotator-change",
  "rotator__item": "QvPQ_a_rotator__item",
  "rotator__list": "QvPQ_a_rotator__list",
  "rotator__window": "QvPQ_a_rotator__window",
  "scroll-bounce": "QvPQ_a_scroll-bounce",
  "scroll-button": "QvPQ_a_scroll-button",
  "scroll-button__icon": "QvPQ_a_scroll-button__icon",
  "scroll-desktop": "QvPQ_a_scroll-desktop",
  "scroll-mobile": "QvPQ_a_scroll-mobile",
  "section-title": "QvPQ_a_section-title",
  "table-block": "QvPQ_a_table-block",
  "tag": "QvPQ_a_tag",
  "visit-community__icon": "QvPQ_a_visit-community__icon",
  "visit-location": "QvPQ_a_visit-location",
  "visit-location--admission": "QvPQ_a_visit-location--admission",
  "visit-location__card": "QvPQ_a_visit-location__card",
  "visit-location__container": "QvPQ_a_visit-location__container",
});
